import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Vehicle Profile</h3>
                <p className="text-sm text-gray-600">
                    Comprehensive overview and management for an individual vehicle.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Tabs and History</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li><strong>Overview:</strong> Key specifications and current status.</li>
                    <li><strong>Fuels/Meters/Expenses:</strong> Logged history specific to this unit.</li>
                    <li><strong>Reminders:</strong> Upcoming tasks specifically for this vehicle.</li>
                    <li><strong>Media:</strong> Uploaded documents, photos, or registration scans.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Quick Actions</h4>
                <p className="text-sm text-gray-600">
                    Depending on the active tab, the "Add" button allows you to quickly log new fuel entries, meter readings, or expenses without leaving the vehicle view.
                </p>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Filtering</h4>
                <p className="text-sm text-gray-600">
                    Use the <strong>Date Range</strong> filter at the top to see historical logs for this vehicle over different time periods.
                </p>
            </section>
        </div>
    );
};

export default Help;
